import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { IonCard, IonIcon, IonRouterLink, IonText } from '@ionic/angular/standalone';
import { BASE_CONFIG } from '@libs/core/base-config';
import { NgEventBus } from '@libs/core/lib/event-bus/ng-event-bus';
import { VxCurrencyPipe } from '@libs/core/lib/pipes/mtjr-currency.pipe';
import { TranslatePipe } from '@ngx-translate/core';

import { VxBlurImgComponent } from '@libs/core/lib/shared/mtjr-blur-image.component';
import { Entity } from '@libs/mtjr/shared/generated/types';
import { HeartButtonComponent } from '@libs/mtjr/shared/products/heart_button.component';
@Component({
  selector: 'mtjr-product-card',
  imports: [
    IonCard,
    RouterLink,
    IonRouterLink,
    IonIcon,
    IonText,
    HeartButtonComponent,
    VxCurrencyPipe,
    TranslatePipe,
    VxBlurImgComponent,
  ],
  templateUrl: './product_card.component.html',
})
export class VxProductCardComponent {
  product = input.required<Entity.Product>();
  isFromVendorDetailsPage = false;
  baseLink = input<string>();
  productDetailsRouterLink = computed(() => {
    const routerLink = [];
    if (this.isFromVendorDetailsPage) {
      const baseLink = this.baseLink();
      if (baseLink) {
        routerLink.push(baseLink, 'products', this.product().id);
      } else {
        routerLink.push('products', this.product().id);
      }
    } else {
      routerLink.push('vendors', this.product().vendorId, 'products', this.product().id);
    }

    return routerLink;
  });
  isVendorOwner = inject(BASE_CONFIG).flavor === 'vendors';
  eventBus = inject(NgEventBus);

  isVoucherVendor = computed(() => {
    const product = this.product();
    return product.vendor?.vendorType === 'voucher';
  });

  priceRange = computed(() => {
    const product = this.product();
    if (product.variations && product.variations.length > 0) {
      const prices = product.variations.map((v) => v.price);
      return {
        min: Math.min(...prices),
        max: Math.max(...prices),
      };
    }
    return null;
  });
  router = inject(Router);
  constructor() {
    this.isFromVendorDetailsPage = this.router.url.includes('/vendors/');
  }
}
